export interface LegacyWorkScheduleHistoryItem {
  id: string
  date: string
  workingTypeName: string
  staffName: string
}

/** Anonymous static history used only by the local S-03 popup. */
export const legacyWorkScheduleHistory: LegacyWorkScheduleHistoryItem[] = [
  {
    id: 'mock-history-1',
    date: '2026-08-20 09:30',
    workingTypeName: 'Mock 일정 등록',
    staffName: 'Mock 직원 A',
  },
  {
    id: 'mock-history-2',
    date: '2026-08-21 14:10',
    workingTypeName: 'Mock 내용 수정',
    staffName: 'Mock 직원 B',
  },
]
